<template>
  <div
    v-bind="$attrs"
    class="strapi-content-wrapper text-h"
    v-html="richText"
  ></div>
</template>
<script lang="ts" setup>
defineProps<{ richText: string }>()
</script>

<style lang="postcss">
@import '~/assets/css/typography.css';
</style>
